import FAQBridgeSettings from '@/components/bot/FAQBridgeSettings'
import FAQManager from '@/components/bot/FAQManager'
import BotSettingsNavTabs from '@/components/bot/BotSettingsNavTabs'
import { HelpCircle } from 'lucide-react'

export default function FAQSettings() {
  return (
    <div className="p-4 sm:p-6 overflow-x-hidden min-h-screen bg-slate-50">
      {/* Header */}
      <div className="mb-4 sm:mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#075E54]/10 rounded-xl flex items-center justify-center flex-shrink-0">
            <HelpCircle className="w-5 h-5 text-[#075E54]" />
          </div>
          <div>
            <h1 data-tour="faq-main" className="text-xl sm:text-2xl font-bold text-gray-900 leading-tight">Preguntas Frecuentes y Continuidad de Ventas</h1>
            <p className="text-xs sm:text-sm text-gray-600">
              Administra las dudas habituales de tus clientes (métodos de pago, envíos, garantías) y personaliza cómo el asistente retoma la conversación de compra.
            </p>
          </div>
        </div>
      </div>

      <BotSettingsNavTabs />

      <div className="bg-white rounded-2xl border border-slate-200/80 shadow-sm mb-6">
        <FAQBridgeSettings />
      </div>

      <div data-tour="faq-list" className="bg-white rounded-2xl border border-slate-200/80 shadow-sm">
        <FAQManager />
      </div>
    </div>
  )
}
